module.exports = __webpack_public_path__ + "fonts/brlnsdb.b6539b6d.ttf";